<template>
  <div class="print_report_container">
    <el-button class="print_btn" size="large" type="primary" @click="print"
      >打印</el-button
    >
    <div class="report_top">
      <h1 class="title">体检报告单</h1>
      <img class="logo" src="@/assets/print-img/logo.jpg" />
    </div>
    <div class="myinfo">
      <div class="myinfo_text">
        <span>宝宝：{{ babyInfo.user.child_name }}</span>
        <span>年龄：{{ babyInfo.user.age }}</span>
      </div>
      <div class="myinfo_text">
        <span>性别：{{ babyInfo.user.sex }}</span>
        <span>电话：{{ babyInfo.user.parent_tel }}</span>
      </div>
      <div class="myinfo_img">
        <img
          v-if="babyInfo.user.sex === '男'"
          class="touxiang"
          src="@/assets/print-img/girl.jpg"
        />
        <img v-else class="touxiang" src="@/assets/print-img/girl.jpg" />
      </div>
    </div>
    <div class="content">
      <div
        v-if="babyInfo.system && babyInfo.system.result"
        class="content_items"
      >
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">体质评测结果分析</span>
          </div>
        </div>
        <div class="mid">
          <div class="mid_results">
            宝宝体质：
            <span class="num">{{ babyInfo.system.result }}</span>
          </div>
          <div class="mid_Imgs">
            <img class="img" src="@/assets/print-img/deer.jpg" />
            <div
              ref="physicalImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">主要特征：{{ babyInfo.system.detail }}</li>
              <li class="item">调养法则：{{ babyInfo.system.rule }}</li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.system.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        v-if="babyInfo.physique && babyInfo.physique.height"
        class="content_items"
      >
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">身高测量/分析</span>
          </div>
        </div>
        <div class="mid">
          <div class="mid_results">
            宝宝身高：
            <span class="num">{{ babyInfo.physique.height.result.num }}</span>
          </div>
          <div class="mid_Imgs">
            <img class="img" src="@/assets/print-img/deer.jpg" />
            <div
              ref="heightImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">评测结果：{{ babyInfo.physique.height.say }}</li>
              <li class="item">
                调养法则：{{ babyInfo.physique.height.rule }}
              </li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.physique.height.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_items">
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">体重测量/分析</span>
          </div>
        </div>
        <div class="mid">
          <div class="mid_results">
            宝宝体重：
            <span class="num">{{ babyInfo.physique.weight.result.num }}</span>
          </div>
          <div class="mid_Imgs">
            <img class="img" src="@/assets/print-img/deer.jpg" />
            <div
              ref="weightImg"
              class="echarts"
              style="width: 270px; height: 160px;"
            />
          </div>
          <div class="mid_details">
            <ul class="ul_items">
              <li class="item">评测结果：{{ babyInfo.physique.weight.say }}</li>
              <li class="item">
                调养法则：{{ babyInfo.physique.weight.rule }}
              </li>
              <li class="item">
                潜在问题：
                <ol class="items_ol">
                  <li
                    v-for="(item, index) in babyInfo.physique.weight.question"
                    :key="index"
                  >
                    <span class="ol_index">{{ index + 1 + '、' }}</span>
                    <span>{{ item }}</span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_items">
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">整体解决方案</span>
          </div>
        </div>
        <div v-if="progress" class="mid">
          <div v-if="typeof progress.fit_tuina === 'string'" class="programme">
            <span class="programme_title">推拿：</span>
            <p class="programme_text">{{ progress.fit_tuina }}</p>
          </div>

          <div v-else-if="progress.fit_tuina.length" class="programme">
            <span class="programme_title">推拿：</span>
            <p class="programme_text">
              {{ progress.fit_tuina.map(e => e.type_name).join('、') }}
            </p>
          </div>

          <div v-if="progress.stick.length > 0" class="programme">
            <span class="programme_title">贴敷：</span>
            <p
              v-for="(item, index) in progress.stick"
              :key="index"
              class="programme_text"
            >
              {{ item.type_name }} -- {{ item.describe }}
            </p>
          </div>

          <div
            v-if="progress.physical && progress.physical.length > 0"
            class="programme"
          >
            <span class="programme_title">理疗：</span>
            <p
              v-for="(item, index) in progress.physical"
              :key="index"
              class="programme_text"
            >
              {{ item.type_name }} -- {{ item.describe }}
            </p>
          </div>

          <div
            v-if="progress.bubble && progress.bubble.length > 0"
            class="programme"
          >
            <span class="programme_title">泡浴：</span>
            <p
              v-for="(item, index) in progress.bubble"
              :key="index"
              class="programme_text"
            >
              {{ item.type_name }} -- {{ item.describe }}
            </p>
          </div>

          <div
            v-if="progress.nutrition && progress.nutrition.length"
            class="programme"
          >
            <span class="programme_title">营养补充：</span>
            <p
              v-for="(item, index) in progress.nutrition"
              :key="index"
              class="programme_text"
            >
              {{ item.type_name }} -- {{ item.describe }}
            </p>
          </div>

          <div
            v-if="progress.medicine && progress.medicine.length"
            class="programme"
          >
            <span class="programme_title">药食同源：</span>
            <p
              v-for="(item, index) in progress.medicine"
              :key="index"
              class="programme_text"
            >
              {{ item.type_name }} -- {{ item.describe }}
            </p>
          </div>
          <div v-if="sayList && sayList.length" class="programme">
            <span class="programme_title">日常护理：</span>
            <div class="programme_text">
              <p
                v-for="(item, index) in sayList"
                :key="item.doctor_say"
                class="item"
              >
                {{ index + 1 + '、' }}{{ item.doctor_say }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="content_items">
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">营养食谱</span>
          </div>
        </div>
        <div v-if="foodList.length" class="mid active">
          <div v-for="food in foodList" :key="food.food" class="mid_up">
            <div class="active_p">
              <div>品名：{{ food.food }}</div>
              <div>食材：{{ food.food_detail }}</div>
              <div class="food_menu">
                <span>做法：</span>
                <span class="flex1" v-html="food.food_do" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="progress" class="content_items">
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">参考文献</span>
          </div>
        </div>
        <div class="mid">
          <ul class="bookList">
            <li class="item">
              {{ progress.book.map(item => item.from_book).join('、') }}
            </li>
          </ul>
        </div>
      </div>
      <div class="content_items">
        <div class="title">
          <div class="Base_img">
            <img class="ico" src="@/assets/print-img/xuehua.png" />
            <span class="text">推荐产品</span>
          </div>
        </div>
        <div class="mid">
          <ul class="productList">
            <li v-for="item in productList" :key="item" class="item">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import {http} from '@/util';
import url from '@/config';

export default {
  props: {
    u_id: [Number, String]
  },

  data() {
    return {
      babyInfo: {
        system: {},
        user: {},
        physique: {
          height: {
            result: {}
          },
          weight: {
            result: {}
          },
          result: {}
        }
      },
      physicalImg: null,
      heightImg: null,
      weightImg: null,
      handList: null,
      handListSimple: null,
      sayList: [],
      foodList: [],
      progress: null,
      productList: [],
      product: null,
      recommendProductId: []
    };
  },
  mounted() {
    http.post(url.testResult, {u_id: this.u_id}).then(res => {
      this.babyInfo = res;
      if (!this.babyInfo) return;
      this.handList = res.solution.hand;
      this.handListSimple = res.solution.hand_simple;
      this.sayList = res.solution.solution.sayList;
      this.foodList = res.solution.solution.foodList;
      res.solution.solution.book = res.solution.solution.book || [];
      this.progress = res.solution.solution;
      this.recommendProductId = res.product.commodity.map(it => it.id);
      res.product.more = res.product.commodity.concat(res.product.more);
      res.product.more.forEach(it => {
        it.number = 1;
        it.now_price = it.price;
        it.all_price = it.price;
      });
      this.product = res.product.more;
      this.productList = this.product
        .filter(item => this.recommendProductId.includes(item.id))
        .map(item => item.commodity_name);
      this.getCharts();
    });
  },

  methods: {
    print() {
      window.print();
    },
    getCharts() {
      http.post(url.physicalImg, {u_id: this.u_id}).then(res => {
        this.physicalImg = res;
        if (!this.physicalImg) return;
        this.$nextTick(_ => {
          const myChart = echarts.init(this.$refs.physicalImg);
          const option = {
            tooltip: {},
            grid: {
              top: 10,
              bottom: 0,
              left: 0,
              right: 0,
              containLabel: true,
              show: true
            },
            xAxis: {
              data: this.physicalImg.name
            },
            yAxis: {},
            series: [
              {
                name: '体质',
                type: 'bar',
                data: this.physicalImg.grade
              }
            ]
          };
          myChart.setOption(option);
        });
      });

      http.post(url.heightImg, {u_id: this.u_id}).then(res => {
        this.heightImg = res;
        if (!this.heightImg) return;
        const myChart = echarts.init(this.$refs.heightImg);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: 30,
            bottom: 0,
            left: 10,
            right: 20,
            containLabel: true,
            show: true
          },
          legend: {
            top: 0
          },
          xAxis: {
            scale: true,
            name: '月'
            // nameLocation: 'start',
          },
          yAxis: {
            name: '厘米'
          },
          series: [
            {
              name: '标准线',
              symbolSize: 0,
              smooth: true,
              type: 'line',
              data: this.heightImg.data[0].data
            },
            {
              name: '宝宝身高',
              symbolSize: 10,
              itemStyle: {
                normal: {
                  color: '#000',
                  lineStyle: {
                    color: '#000'
                  }
                }
              },
              type: 'scatter',
              data: this.heightImg.data[1].data
            }
          ]
        };
        myChart.setOption(option);
      });
      http.post(url.weightImg, {u_id: this.u_id}).then(res => {
        this.weightImg = res;
        if (!this.weightImg) return;
        const myChart = echarts.init(this.$refs.weightImg);
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: 30,
            bottom: 0,
            left: 10,
            right: 20,
            containLabel: true,
            show: true
          },
          legend: {
            top: 0
          },
          xAxis: {
            scale: true,
            name: '月'
            // nameLocation: 'start',
          },
          yAxis: {
            name: '千克'
          },
          series: [
            {
              name: '标准线',
              symbolSize: 0,
              smooth: true,
              type: 'line',
              data: this.weightImg.data[0].data
            },
            {
              name: '宝宝体重',
              symbolSize: 10,
              itemStyle: {
                normal: {
                  color: '#000',
                  lineStyle: {
                    color: '#000'
                  }
                }
              },
              type: 'scatter',
              data: this.weightImg.data[1].data
            }
          ]
        };
        myChart.setOption(option);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media print {
  .print_btn {
    display: none !important;
  }
}

.print_btn {
  position: absolute;
  right: -80px;
  top: 40px;
}

.print_report_container {
  position: relative;
  margin: 0 auto;
  width: 700px;
  font-size: 14px;
  color: black;
}

.print_report_container ul li {
  list-style: none;
}

.print_report_container ol li {
  padding-left: 20px;
  position: relative;
}

.print_report_container ol .ol_index {
  position: absolute;
  left: 0;
}

.print_report_container .food_menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.print_report_container .report_top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 68px;
  border-bottom: 5px solid #4b90ff;
  padding-left: 46px;
}

.report_top .title {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 18px;
  font-weight: bold;
  color: #4b90ff;
}

.report_top .logo {
  width: 30px;
  height: 38px;
}

.print_report_container .myinfo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 46px;
  height: 122px;
}

.myinfo .myinfo_text {
  width: 160px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.myinfo .myinfo_img {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.myinfo_img .touxiang {
  width: 97px;
  height: 97px;
  margin-right: 30px;
}

.print_report_container .content {
  margin-left: 10px;
}

.content .content_items {
  width: 100%;
  -webkit-print-color-adjust: exact;
  page-break-inside: avoid;
}

.content_items .title .Base_img {
  height: 30px;
  line-height: 30px;
  background-image: url('../assets/print-img/title1.png');
  background-size: contain;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 3px solid #4b90ff;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.content_items .title .text {
  font-size: 16px;
  color: white;
}

.content_items .title .Base_img .ico {
  padding-left: 10px;
  padding-right: 5px;
  width: 25px;
  height: 25px;
}

.content_items .mid {
  margin-left: 33px;
  margin-top: 17px;
  margin-bottom: 22px;
}

.mid .mid_results .num {
  font-size: 14px;
  color: #4b90ff;
}

.mid .mid_Imgs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 210px;
  padding-right: 60px;
  padding-left: 45px;
}

.mid .mid_Imgs .img {
  height: 155px;
}

.mid .programme {
  margin-bottom: 23px;
  font-size: 14px;
  color: black;
}

.mid .programme .programme_title {
  font-size: 14px;
  color: #4b90ff;
}

.mid .programme .programme_text {
  margin-top: 5px;
  line-height: 24px;
}

.content_items .active {
  border: 2px dashed #4b90ff;
  margin-top: 22px;
  margin-bottom: 22px;
  margin-right: 20px;
}

.content_items .active .active_p {
  margin: 10px 5px;
  line-height: 22px;
}

.mid .mid_up {
  margin: 0 5px;
  border-bottom: 2px dashed #4b90ff;
}

.mid .mid_up:last-child {
  border: none;
}

.mid .bookList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.mid .bookList .item {
  margin-top: 10px;
}

.mid .productList .item {
  margin-bottom: 15px;
}

.mid .mid_details .ul_items .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 22px;
}

.ul_items .items_ol {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
/*# sourceMappingURL=index.css.map */
</style>
